export default __webpack_public_path__ + "img/Rangitikei.338c9497.png";